import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { ApiRoutes } from 'src/app/config/api-routes';
import { Observable, of } from 'rxjs';

@Injectable()
export class ForgotPasswordService {
  constructor(private httpClient: HttpClient, private config: ApiRoutes) {}

  public resetPassword(email: string): Observable<any> {
    return this.httpClient.post(this.config.FORGOT_PASSWORD, { "username": email });
  }
}

